import { ReactNode } from "react";

export default function Pending(): ReactNode {
  return (
    <article className="flex flex-col gap-5 items-center text-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="86"
        height="86"
        fill="currentColor"
        className="text-yellow-400 bi bi-clock"
        viewBox="0 0 16 16"
      >
        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
      </svg>

      <section className="text-wrap text-zinc-400">
        <h4 className="mb-5 font-bold" style={{ color: "#1b1b1b" }}>
          Payment pending!
        </h4>

        <p>An receipt will be sent to your email. If the order succeeds.</p>
        <p>
          Please check your spam folder if you don't see the email in your
          inbox.
        </p>
      </section>
    </article>
  );
}
